import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mail } from 'src/app/shared/models/mails/mail';
@Component({
  selector: 'app-super-list-new-visual',
  templateUrl: './super-list.component.html',
  styleUrls: ['./super-list.component.scss'],
})
export class SuperListNewVisualComponent implements OnInit {
  public itemsArray: Mail[] = [];
  public selected_by_id: boolean[] = [];
  public selected: Mail[] = [];
  public selectAll: boolean = false;

  @Input() activeItem: number;
  @Input() set items(value: Mail[]) {
    if (value.length > 0) {
      if (this.activeItem) {
        value.filter((item, index) => {
          if (item.id === this.activeItem) {
            value[index].active = true;
          }
        });
      } else {
        value[0].active = true;
      }
      this.itemsArray = value;
    }
  }
  @Input() boolMultiSelect: boolean;
  @Input() keyLockTooltip?: string;
  @Input() isAdvancedSearch?: boolean = false; //is used to know if we're in an advancedSearch or not. Conjoined with item.isTheItemToDisplayMoreMails to have the margin-bottom :)
  @Output() multiSelectValue: EventEmitter<Mail[]> = new EventEmitter();
  @Output() selectedValue: EventEmitter<{ obj: Mail }> = new EventEmitter();
  @Input() set resetSelectedItems(value: boolean) {
    if (value) {
      this.itemsArray.map((_item, index) => {
        this.selected_by_id[index] = false;
      });
    }
  }

  ngOnInit(): void {
    this.itemsArray.map((_item, index) => {
      this.selected_by_id[index] = false;
    });
  }

  toggleLine(arg: Mail): void {
    this.itemsArray.map((item) => {
      item.active = false;
    });
    arg.active = true;
  }

  public function_two(obj: Mail): void {
    this.selectedValue.emit({ obj: obj });
  }

  selectItem(event, index: number): void {
    this.selected_by_id[index] = event.currentTarget.checked;
    this.emit();
  }

  selectAllItems(): void {
    this.selectAll = !this.selectAll;
    this.itemsArray.map((_item, j) => {
      this.selected_by_id[j] = this.selectAll;
    });
    this.emit();
  }

  emit(): void {
    this.selected = this.itemsArray.filter((_x, j) => this.selected_by_id[j]);
    this.multiSelectValue.emit(this.selected);
  }
}
